import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments';
import { Balance7ComparativaEncabezadoDTO } from '@shared/models/cierreTurno/Balance7ComparativaEncabezadoDTO';
import { Balance7MedicionesDTO } from '@shared/models/cierreTurno/Balance7MedicionesDTO';
import { CierreTurno } from '@shared/models/cierreTurno/CierreTurno';
import { Comparativas } from '@shared/models/cierreTurno/Comparativas';
import { contenedorCierre } from '@shared/models/cierreTurno/contenedorCierre'
import { Precierre } from '@shared/models/cierreTurno/Precierre';
import { ReporteMovimientoBalance7 } from '@shared/models/cierreTurno/ReporteMovimientoBalance7';
import { Comparativa } from '@shared/models/cierreTurno/Comparativa';
import { Balance7ActaDTO } from '@shared/models/cierreTurno/FechaDto';
import { FechaDTO } from '@shared/models/cierreTurno/Balance7ActaDTO';
import { Balance7ActaDocumentosDTO } from '@shared/models/cierreTurno/Balance7ActaDocumentosDTO';
import { ReporteMovimientoPorTipoBalance7 } from '@shared/models/cierreTurno/ReporteMovimientoPorTipoBalance7';
import { ReporteMovimientoDetalleBalance7 } from '@shared/models/cierreTurno/ReporteMovimientoDetalleBalance7';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { EstadoTanque } from '@shared/models/cierreTurno/EstadoTanque';
import { EstadoExpendedora } from '@shared/models/cierreTurno/EstadoExpendedora';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';
import { Contacto } from '@shared/models/cierreTurno/Contacto';
import { ResolucionConfiguracion } from '@shared/models/cierreTurno/ResolucionConfiguracion';
import { TipoTransaccion } from '@shared/enums/TipoTransaccion';
import { GrupoContacto } from '@shared/enums/GrupoContacto';
import { BotonGrupo } from '@shared/models/cierreTurno/BotonesGrupo';

export interface step {
  label: string, 
  completed: boolean
}
@Injectable({
  providedIn: 'root'
})
export class CierreTurnoService {

  cierreTurnoBase = environment.apiServer.cierreTurnoBaseUrl;
  stockBase = environment.apiServer.stockBaseUrl;
  facturacionBase = environment.apiServer.facturacionBaseUrl;
  private cierreURL = this.cierreTurnoBase + '/CierresTurnosV1/';
  private precierreURL = this.cierreTurnoBase + '/PrecierresV1/';
  private balance7URL = this.cierreTurnoBase + '/Balance7V1/';
  private reportesUrl = this.stockBase + '/ReportesV1/'; 
  private facturacionUrl = this.facturacionBase + '/FacturacionV1/';
  private aeroplantasUrl = this.cierreTurnoBase + '/AeroplantasV1';

  estadoTanque: EstadoTanque;
  estadoExpendedora: EstadoExpendedora;  

  private configuracionesURL = this.cierreTurnoBase + '/ConfiguracionesV1/';

  aeroplantas:any;

  constructor(private http: HttpClient) {      
  }

  ObtenerCierresTurnos(): Observable<CierreTurno[]> {
    return this.http.get<CierreTurno[]>(this.cierreTurnoBase + "/CierresTurnosV1");
  }

  // UltimoMovimientoContenedores(cierreTurnoId: string): Observable<movimiento> {
  //   return this.http.get<movimiento>(this.cierreTurnoBase + "/MovimientosV1/" + cierreTurnoId)
  // }

  ObtenerMovimientosDeContenedoresCierreDeTurno(cierreTurnoId: string): Observable<contenedorCierre[]> {
    return this.http.get<contenedorCierre[]>(this.cierreTurnoBase + "/MovimientosV1/" + cierreTurnoId)
  }

  getCierreSegunEstado(codigoAeroplanta: string, estado: number): Observable<CierreTurno> {
    return this.http.get<CierreTurno>(this.cierreURL + 'Estado?codigoAeroplanta=' + codigoAeroplanta + '&estado=' + estado)
  }

  getCierresPorFecha(codigoAeroplanta: string, desde: string, hasta: string): Observable<CierreTurno[]> {
    return this.http.get<CierreTurno[]>(this.cierreTurnoBase + '/CierresTurnosV1?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta)
  }

  precerrarAbastecedora(cierreId: string, precierre: Precierre){
    return this.http.post<Comparativas>(this.precierreURL + cierreId, precierre);
  }

  actualizarPrecierreAbastecedora(cierreId: string, precierre: Precierre){
    return this.http.put<Comparativas>(this.precierreURL + cierreId, precierre);
  }

  getUltimasMedicionesBalance7(codigoAeroplanta: string, desde: string, hasta: string): Observable<Balance7MedicionesDTO> {
    return this.http.get<Balance7MedicionesDTO>(this.balance7URL + 'UltimasMediciones?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta)
  }

  getComparativasBalance7(codigoAeroplanta: string, desde: string, hasta: string): Observable<Balance7ComparativaEncabezadoDTO> {
    return this.http.get<Balance7ComparativaEncabezadoDTO>(this.balance7URL + 'Comparativas?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta)
  }

  getComparativaDetalleBalance7(cierreTurnoId: string, codigoProducto: string, tipoComparativa: number): Observable<Comparativa[]> {
    return this.http.get<Comparativa[]>(this.balance7URL + 'ComparativasPorCierreDeTurno?cierreTurnoId=' + cierreTurnoId + '&codigoProducto=' + codigoProducto + '&tipoComparativa=' + tipoComparativa)
  }

  getIdsCierreTurnoBalance7PorCierre(codigoAeroplanta: string, desde: string, hasta: string): Observable<string[]> {
    return this.http.get<string[]>(this.cierreURL + 'CierresIds?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta)
  }

  getMovimientosBalance7PorFecha(listaIdsCierreTurno: string[], codigoAeroplanta: string, desde: string, hasta: string, incluirAjustes: boolean): Observable<ReporteMovimientoBalance7[]> {   
    return this.http.put<ReporteMovimientoBalance7[]>(this.reportesUrl + 'Fechas/ReporteMovimientos?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta +'&incluirAjustes=' + incluirAjustes, listaIdsCierreTurno)
  }

  getMovimientosBalance7PorFechaPromise(listaIdsCierreTurno: string[], codigoAeroplanta: string, desde: string, hasta: string, incluirAjustes: boolean): Promise<ReporteMovimientoBalance7[]> {   
    return this.http.put<ReporteMovimientoBalance7[]>(this.reportesUrl + 'Fechas/ReporteMovimientos?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta +'&incluirAjustes=' + incluirAjustes, listaIdsCierreTurno).toPromise();
  }
  
  obtenerReporteMovimientoAgrupadoPorTipoCierreTurno(listaIdsCierreTurno:string[], codigoProducto:string, codigoAeroplanta: string, tipoReporte: boolean, incluirAjustes: boolean): Observable<ReporteMovimientoPorTipoBalance7[]> {
    return this.http.put<ReporteMovimientoPorTipoBalance7[]>(this.reportesUrl + 'CierreTurno/ReporteMovimientos/AgrupadoPorTipo?codigoProducto=' + codigoProducto + '&codigoAeroplanta=' + codigoAeroplanta + '&tipoReporte=' + tipoReporte + '&incluirAjustes=' + incluirAjustes, listaIdsCierreTurno)
  }

  obtenerReporteMovimientoAgrupadoPorTipoFecha(codigoProducto:string, codigoAeroplanta: string, tipoReporte: boolean, desde: string, hasta: string, incluirAjustes: boolean): Observable<ReporteMovimientoPorTipoBalance7[]> {
    return this.http.put<ReporteMovimientoPorTipoBalance7[]>(this.reportesUrl + 'Fechas/ReporteMovimientos/AgrupadoPorTipo?codigoProducto=' + codigoProducto + '&codigoAeroplanta=' + codigoAeroplanta + '&tipoReporte=' + tipoReporte + '&incluirAjustes='+incluirAjustes+'&fechaDesde='+desde+'&fechaHasta='+hasta, null)
  }

  getMovimientosBalance7(listaIdsCierreTurno: string[], codigoAeroplanta: string, incluirAjustes: boolean): Observable<ReporteMovimientoBalance7[]> {
    return this.http.put<ReporteMovimientoBalance7[]>(this.reportesUrl + 'CierreTurno/ReporteMovimientos?codigoAeroplanta='+codigoAeroplanta+'&incluirAjustes=' + incluirAjustes, listaIdsCierreTurno);
  }

  getDatosGeneralesActaBalance7(codigoAeroplanta: string, desde: string, hasta: string): Observable<Balance7ActaDTO[]> {
    return this.http.get<Balance7ActaDTO[]>(this.balance7URL + 'acta?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta)
  }

  getDatosFechaActaBalance7(codigoAeroplanta: string, desde: string, hasta: string): Observable<FechaDTO> {
    return this.http.get<FechaDTO>(this.cierreURL + 'CierresFechas?codigoAeroplanta=' + codigoAeroplanta + '&fechaDesde=' + desde + '&fechaHasta=' + hasta)
  }

  getDatosFacturacionActaBalance7(codigoAeroplanta: string, hasta: string, desde:string): Observable<Balance7ActaDocumentosDTO[]> {
    return this.http.get<Balance7ActaDocumentosDTO[]>(this.facturacionUrl + 'acta?codigoAeroplanta=' + codigoAeroplanta + '&fechaHasta=' + hasta + '&fechaDesde=' + desde)
  }

  obtenerReporteMovimientoDetalleFecha(codigoProducto:string, codigoAeroplanta: string, natural: boolean, tipoTransaccion:number, esAnulacion:boolean, desde: string, hasta: string): Observable<ReporteMovimientoDetalleBalance7[]> {
    return this.http.put<ReporteMovimientoDetalleBalance7[]>(this.reportesUrl + 'Fechas/ReporteMovimientos/Detalle?codigoProducto=' + codigoProducto + '&codigoAeroplanta=' + codigoAeroplanta + '&tipoReporte=' + natural + '&tipoTransaccion=' + tipoTransaccion + '&esAnulacion=' + esAnulacion + '&fechaDesde=' + desde + '&fechaHasta=' + hasta, null)
  }
    
  obtenerReporteMovimientoDetalleCierreTurno(listaIdsCierreTurno: string[], codigoProducto:string, codigoAeroplanta: string, natural: boolean, tipoTransaccion:number, esAnulacion:boolean): Observable<ReporteMovimientoDetalleBalance7[]> {
    return this.http.put<ReporteMovimientoDetalleBalance7[]>(this.reportesUrl + 'CierreTurno/ReporteMovimientos/Detalle?codigoProducto=' + codigoProducto + '&codigoAeroplanta=' + codigoAeroplanta + '&tipoReporte=' + natural + '&tipoTransaccion=' + tipoTransaccion + '&esAnulacion=' + esAnulacion, listaIdsCierreTurno)
  }

  obtenerResolucionConfiguracion(id:string): Observable<ResolucionConfiguracion> {
    return this.http.get<ResolucionConfiguracion>(this.configuracionesURL + `${id}/ObtenerResolucionConfiguracion`);
  }

  descargarParteDiarioPdf(file): Observable<any> {
    const imagenParteDiario = new FormData();
    imagenParteDiario.append('imagen', file);


    return this.http.post<any>(this.cierreURL + 'FormatearImagenAPDF', imagenParteDiario, {  responseType: 'blob' as 'json' });
  }

  // UTILIDADES

  obtenerDescripcionTipoTransaccion(tipoTransaccion : number, esAnulacion : boolean){
    if (Object.values(TipoTransaccion).includes(tipoTransaccion)) {
      return tipoTransaccion === TipoTransaccion.AjusteManual ?  (esAnulacion ? "Anulación " : "" + "Ajuste Manual") : 
        tipoTransaccion === TipoTransaccion.AjusteAutomatico ? (esAnulacion ? "Anulación " : "" + "Ajuste Automatico") : 
        (esAnulacion ? "Anulación " : "") + TipoTransaccion[tipoTransaccion];
    } else {
        return "Tipo de transacción no válido";
    }
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {   
    const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'Movimientos': worksheet }, SheetNames: ['Movimientos'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });

    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }
      
  /** Aeroplanta -> msCierreTurno */

  getAeroplantas(codigoAeroplanta:string):Promise<Aeroplanta>{
    return this.http.get<Aeroplanta>(`${this.aeroplantasUrl}/${codigoAeroplanta}/ObtenerAeroplanta`).toPromise();
  }

  getAeroplantas3():Observable<Aeroplanta[]>{
    return this.http.get<Aeroplanta[]>(`${this.aeroplantasUrl}`);
  }

  //api/AeroplantasV1/ActualizarAeroplanta
  putAeroplantas(body:Aeroplanta):Promise<Aeroplanta>{
    return this.http.put<Aeroplanta>(`${this.aeroplantasUrl}/ActualizarAeroplanta`, body).toPromise();
  }

  /** Contactos */

  getContactos():Promise<Contacto[]>{
    return this.http.get<Contacto[]>(`${this.aeroplantasUrl}/ObtenerContactos`).toPromise();
  }

  postContactos(body:Contacto):Promise<Contacto>{
    return this.http.post<Contacto>(`${this.aeroplantasUrl}/CrearContacto`, body).toPromise();
  }

  putContactos(body:Contacto):Promise<Contacto>{
    return this.http.put<Contacto>(`${this.aeroplantasUrl}/EditarContacto`, body).toPromise();
  }

  deleteContactos(id: string):Promise<Contacto> {
    return this.http.delete<Contacto>(`${this.aeroplantasUrl}/EliminarContacto/${id}`).toPromise();
  }
  get botonesGrupo(): BotonGrupo[] {
    return [
      { nombre: 'Firma Operador', valor: GrupoContacto.firmaOperador, seleccionado: false },
      { nombre: 'Referente Comercial', valor: GrupoContacto.referenteComercial, seleccionado: false },
      { nombre: 'Referente Gestión', valor: GrupoContacto.referenteGestion, seleccionado: false },
      { nombre: 'Referente Técnico', valor: GrupoContacto.referenteTecnico, seleccionado: false },
      { nombre: 'Ruteador', valor: GrupoContacto.ruteador, seleccionado: false }
    ];
  }
}
